import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { externalIntegrationsQueryKeys } from 'queries/external-integrations/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { IntegrationResponse } from 'queries/external-integrations/types'
import type { TeamExternalIntegrationResponse } from 'types/api/status-checks/status-check'

type Options = Omit<
  QueryObserverOptions<TeamExternalIntegrationResponse[], AxiosError>,
  'queryKey' | 'queryFn'
>

async function fetchStatusChecks({
  queryKey: [endpoint, { teamId }]
}: QueryFunctionContext<
  ReturnType<typeof externalIntegrationsQueryKeys.getStatusCheckIntegrations>
>) {
  const endpointWithParams = getEndpointWithParams(endpoint, { teamId })
  const response = await fetchQueryData<IntegrationResponse>(endpointWithParams)

  return response.integrations
}

export const useGetExternalIntegrationsStatusChecks = (
  ...params: [string] | [string, Options] | [Options] | []
) => {
  const { currentTeamId } = useAuth()
  const teamId = typeof params[0] === 'string' ? params[0] : currentTeamId
  const options = typeof params[0] === 'string' ? params[1] : params[0]

  return useQuery<TeamExternalIntegrationResponse[], AxiosError>({
    ...options,
    queryFn: fetchStatusChecks,
    queryKey: externalIntegrationsQueryKeys.getStatusCheckIntegrations({
      teamId
    })
  })
}
